import { useEffect, useState } from 'react';
import type { IStep } from 'utils/types';
import { useFeatureFlagEnabled } from 'posthog-js/react';

const defaultSteps: IStep[] = [
  {
    name: 'Target project',
    description: 'Where would you like to create the new project?',
    disabled: false,
  },
  {
    name: 'Execution mode',
    description: 'Select the dbt™ execution mode',
    disabled: false,
  },
  {
    name: 'Source project',
    description: 'Select a source of your dbt project',
    disabled: false,
  },
  {
    name: 'Target database',
    description: 'Select the target database',
    disabled: false,
  },
];

export default function useDbtMigrationSteps(): IStep[] {
  const isDbtInSnowflakeEnabled = useFeatureFlagEnabled('create_dbt_in_snowflake');
  const deploymentEnv = process.env.REACT_APP_ENV;
  const [steps, setSteps] = useState<IStep[]>(defaultSteps);

  useEffect(() => {
    let tmpSteps = [...defaultSteps];

    if (isDbtInSnowflakeEnabled !== true && (deploymentEnv === 'production' || deploymentEnv === 'az')) {
      tmpSteps = tmpSteps.filter((step) => step.name !== 'Execution mode');
    }

    setSteps(tmpSteps);
  }, [isDbtInSnowflakeEnabled]);

  return steps;
}
